document.querySelectorAll('[data-sps-testimonials]').forEach((carousel) => {
  const slides = Array.from(carousel.querySelectorAll('.sps-testimonial'));
  if (slides.length < 2) return;

  const dots = document.createElement('div');
  dots.className = 'sps-testimonials__dots';
  dots.setAttribute('role', 'tablist');
  dots.setAttribute('aria-label', 'Testimonials');

  let activeIndex = 0;
  let rotationTimer;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const controls = slides.map((slide, index) => {
    const control = document.createElement('button');
    control.type = 'button';
    control.className = 'sps-testimonials__dot';
    control.setAttribute('role', 'tab');
    control.setAttribute('aria-label', `Show testimonial ${index + 1}`);
    control.addEventListener('click', () => showSlide(index, true));
    dots.appendChild(control);

    slide.setAttribute('role', 'tabpanel');
    slide.setAttribute('aria-label', `Testimonial ${index + 1} of ${slides.length}`);
    return control;
  });

  carousel.appendChild(dots);
  carousel.classList.add('sps-testimonials--enhanced');

  function showSlide(index, restartRotation = false) {
    activeIndex = (index + slides.length) % slides.length;

    slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === activeIndex;
      slide.classList.toggle('is-active', isActive);
      slide.toggleAttribute('hidden', !isActive);
      controls[slideIndex].setAttribute('aria-selected', String(isActive));
      controls[slideIndex].tabIndex = isActive ? 0 : -1;
    });

    if (restartRotation) startRotation();
  }

  function stopRotation() {
    window.clearInterval(rotationTimer);
  }

  function startRotation() {
    stopRotation();
    if (reducedMotion.matches) return;
    rotationTimer = window.setInterval(() => showSlide(activeIndex + 1), 7000);
  }

  carousel.addEventListener('mouseenter', stopRotation);
  carousel.addEventListener('mouseleave', startRotation);
  carousel.addEventListener('focusin', stopRotation);
  carousel.addEventListener('focusout', (event) => {
    if (!carousel.contains(event.relatedTarget)) startRotation();
  });
  reducedMotion.addEventListener('change', startRotation);

  showSlide(0);
  startRotation();
});
